import React from "react";
import { HeroSection } from "../../graphql/schema";
import {
  tokens,
  makeStyles,
  Text,
  shorthands,
} from "@fluentui/react-components";
import { CtaButton } from "../common/input/CtaButton";
import { useNavigate } from "react-router-dom";
type HeroProps = {
  data: HeroSection;
};
const NAV_HEIGHT = "60px";
const useStyles = makeStyles({
  wrapper: {
    boxShadow: tokens.shadow8,
  },
  hero: {
    display: "none",
    "@media screen and (min-width: 600px)": {
      display: "block",
      backgroundSize: "cover",
      height: "655px",
    },
    "@media screen and (min-width: 1200px)": {
      height: "80vh",
    },
  },
  text: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: "650px",
    color: "white",
  },
  titleWraper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  centerScreen: {
    position: "relative",
    zIndex: 1,
    boxSizing: "border-box",
    minHeight: "calc(95vh - 325px - 50px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...shorthands.padding(
      tokens.spacingVerticalXXXL,
      tokens.spacingHorizontalXXXL,
    ),
    paddingTop: `calc(${NAV_HEIGHT} + ${tokens.spacingVerticalXXXL})`,
  },
});
export const Hero = ({ data }: HeroProps) => {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <article
      className={classes.wrapper}
      style={{ position: "relative", overflow: "hidden", background: "black" }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          // backgroundImage: `url('/images/35RobustHero.webp')`,
          backgroundImage: `url(${data?.image?.url})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.35,
          backgroundColor: "black",
        }}
      />

      <section className={classes.centerScreen}>
        <div className={classes.text}>
          <div className={classes.titleWraper}>
            <Text size={900} align="center" weight="bold">
              {data.title ?? ""}
            </Text>
            <Text size={800} align="center" weight="semibold">
              {data.subTitle ?? ""}
            </Text>
          </div>
          {data.description && (
            <>
              <Text size={400} align="center" as="h2">
                {data.description}
              </Text>
              <Text size={400} align="center" weight="medium">
                {data.descriptionPt2 ?? ""}
              </Text>
            </>
          )}
          {data.buttonText && (
            <CtaButton
              color="alternative"
              buttonText={data.buttonText}
              onClick={() => navigate("/order")}
            />
          )}
        </div>
      </section>
    </article>
  );
};
